<template>
  <div>
    <Schema :text="getSchemaApple" />
    <Schema :text="getSchemaAndroid" />
  </div>
</template>

<script>
import Schema from './json-schema.vue';

const offers = {
  "@type": "Offer",
  "price": "0",
  "priceCurrency": "USD"
};

export default {
  name: 'ApplicationSchema',
  components: { Schema },
  computed: {
    getSchemaApple() {
      const schema = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Movoto Real Estate",
        "operatingSystem": "iOS",
        "applicationCategory": "https://schema.org/LifestyleApplication",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "14800"
        },
        offers
      }
      return JSON.stringify(schema);
    },
    getSchemaAndroid() {
      const schema = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Real Estate by Movoto",
        "operatingSystem": "Android",
        "applicationCategory": "https://schema.org/LifestyleApplication",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.4",
          "ratingCount": "3285"
        },
        offers
      }
      return JSON.stringify(schema);
    },
  },
};
</script>
